import React from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";

import { useState } from "react";

import { makeGetRequest,makePostRequest } from "../../../utils/utils";
import Tooltip from "@mui/material/Tooltip";
import layOutDefault from "../../../assets/Images/layout-defaullt-img2.jpg";
// import FileUploadIcon from "@mui/icons-material/FileUpload";

function ConfigureSecuritySpots() {
  const navigate = useNavigate();
  // let timer = null;

  const [, setlong] = useState("");
  const [, setlati] = useState("");
  const [, setdlon] = useState("");
  const [, setdlat] = useState("");

  const [PlotsArray, SetPlotsArray] = useState([{ x: "0", y: "0" }]);

  const [imgHeight, setImgHeight] = useState(0);
  const [imgWidth, setImgWidth] = useState(0);
  const [societylayout, setSocietyLayout] = useState("");
  const [societyGoogleMapImg, setSocietyGoogleMapImg] = useState("");

  const [ref_latitude, setRef_latitude] = useState();
  const [ref_longitude, setRef_longitude] = useState();

  const [soc_bound_x_mtr, setSoc_bound_x_mtr] = useState();
  const [soc_bound_y_mtr, setSoc_bound_y_mtr] = useState();
  const [spotList, setSpotList] = useState([]);

  const [noGMapErr, setNoGMapErr] = useState("");
  const [showLoader, setShowLoader] = React.useState(false);

  let arr = [];
  let ref_arr = [];

  /********************    For Spot mapping     *************** */

  //let ref_point = {};

  const getStatic_langlong = async () => {
    console.log("function called");

    await getSpotsList();
    console.log("In Func spot ", spotList.length);
    // for (let i = 0; i < response.data.length; i++) {
    for (let i = 0; i < spotList.length; i++) {
      let spot_location_x = spotList[i].longitude; // 73.78926344480345;
      let spot_location_y = spotList[i].latitude; //20.015599710609504;
      console.log(
        "spot_location_x : " + spot_location_x,
        "spot_location_y " + spot_location_y
      );
      console.log("Width : " + imgWidth, "Height " + imgHeight);
      const x_res = imgWidth;
      const y_res = imgHeight;

      let x_min = 0;
      let y_min = 0;

      console.log("x_min", x_min);
      console.log("y_min", y_min);

      // let x_min = 0;
      // let y_min = 100;

      //console.log("x_res >>> " + Math.round(x_min));
      //console.log("y_res >> " + Math.round(y_min));
      let x_max = imgWidth;
      let y_max = imgHeight;
      //console.log("x_max >>> " + Math.round(x_max))
      //console.log("y_max >> " + Math.round(y_max))
      let x_pixel_count = x_max - x_min;
      let y_pixel_count = y_max - y_min;
      // console.log("x_pixel_count >>> " + Math.round(x_pixel_count))
      //console.log("y_pixel_count >> " + Math.round(y_pixel_count))
      // let soc_bound_x_mtr = 69.24;
      // let soc_bound_y_mtr = 33.42;

      let x_pixel_per_mtr = Number(
        (x_pixel_count / soc_bound_x_mtr).toFixed(2)
      );
      let y_pixel_per_mtr = Number(
        (y_pixel_count / soc_bound_y_mtr).toFixed(2)
      );

      // let obj = { x: (x_max).toString(), y: (y_max).toString(), 'color': 'red' }
      // arr.push(obj);
      // SetPlotsArray(obj);
      // let obj1 = { x: (x_min).toString(), y: (y_min).toString(), 'color': 'green' }
      // arr.push(obj1)

      // let ref_latitude = 20.015764288030113;
      // let ref_longitude = 73.78881297277361;

      let dist_x = getDistanceFromLatLonInKm(
        ref_latitude,
        ref_longitude,
        ref_latitude,
        spot_location_x
      );

      let dist_y = getDistanceFromLatLonInKm(
        ref_latitude,
        ref_longitude,
        spot_location_y,
        ref_longitude
      );
      console.log("dist_x " + dist_x);
      console.log("dist_y " + dist_y);
      let cal_x = dist_x * 1000 * x_pixel_per_mtr;
      let cal_y = dist_y * 1000 * y_pixel_per_mtr;
      console.log("cal_x " + cal_x);
      console.log("cal_y " + cal_y);
      let ref_point = {
        x: cal_x.toString(),
        y: cal_y.toString(),
        spotName: spotList[i].spot_name,
      };
      console.log("ref point", ref_point);
      ref_arr.push(ref_point);
    }

    console.log('ref_arr ',ref_arr)
    SetPlotsArray(ref_arr);
  };

  async function getSpotsList() {
    let bodyFormData = {
      searchString:"",
      sortBy:'ASC'
    };
   await makePostRequest("spot/getalllist/", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("Spots Data", response.data.data);
          setSpotList(response.data.data);

          // printCoordinates();
        }
      })
      .catch((err) => {
        console.log("There was an error!", "more error details", "warning");
      });
  }

  const getCoordinate = async () => {
    // const context = context as GlobalContextInput;
    // const userDeviceService = ObjectFactory.getRequestService(context);
    // const responseDevice = await userDeviceService.getAllDevices();
    arr = [];

    // for (let i = 0; i < responseDevice.data.length; i++) {
    for (let i = 0; i < 1; i++) {
      // if (responseDevice.data[i].longitude > 0 && responseDevice.data[i].latitude > 0) {
      if (73.789133 > 0 && 20.014958 > 0) {
        arr.push(...ref_arr);
        setlong(60);
        // let g1_location_x = responseDevice.data[i].longitude; //longitute 73.789133
        // let g1_location_y = responseDevice.data[i].latitude;//latitude 20.014958
        let g1_location_x = 100;
        let g1_location_y = 100;
        setlati(60);
        //console.log(responseDevice.data[i].longitude, " ", responseDevice.data[i].latitude);
        let x_min = 0;
        let y_min = 0;
        let x_max = imgWidth;
        let y_max = imgHeight;
        let x_pixel_count = x_max - x_min;
        let y_pixel_count = y_max - y_min;

        let dist_x = getDistanceFromLatLonInKm(
          ref_latitude,
          ref_longitude,
          ref_latitude,
          g1_location_x
        );
        let dist_y = getDistanceFromLatLonInKm(
          ref_latitude,
          ref_longitude,
          g1_location_y,
          ref_longitude
        );

        let x_pixel_per_mtr = Number(
          (x_pixel_count / soc_bound_x_mtr).toFixed(2)
        );
        let y_pixel_per_mtr = Number(
          (y_pixel_count / soc_bound_y_mtr).toFixed(2)
        );

        //console.log("distance in mtr " + (dist_x) + " " + (dist_y));
        let cal_x = dist_x * 1000 * x_pixel_per_mtr;
        let cal_y = dist_y * 1000 * y_pixel_per_mtr;
        console.log("cal_x " + cal_x + " cal_y " + cal_y);
        setdlon(cal_x.toString());
        setdlat(cal_y.toString());
        let obj3 = {
          x: (cal_x + x_min).toString(),
          y: (cal_y + y_min).toString(),
          color: "green",
        };
        console.log("obj3 ",obj3)
        arr.push(obj3);
      }
    }

    console.log(arr)
    SetPlotsArray(arr);
  };

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6378.137; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  const renderRow = (key, index) => {
    return (
      <>
        <div className="spotCanvas" key={index}>
          <div id="contain" onClick={(e) => printCoordinates(e)}>
            <div
              className="gateName"
              key={key}
              style={{
                position: "absolute",
                backgroundColor: key.color,
                left: Math.round(key.x),
                top: Math.round(key.y),
                width: 15,
                height: 15,
                borderRadius: 10,
              }}
            >
              {" "}
              <span className="pointName">{key.spotName}</span>
            </div>
          </div>
        </div>
        {/* <div className="pointMainSt">
      
        </div> */}
        {/* 
        var div = document.createElement("div");
    console.log(e);
    div.style.position = "absolute";
    div.style.top = e.clientY + "px";
    div.style.left = e.clientX + "px";
    div.innerHTML = "<span>Security Guard</span>";
    document.getElementById("contain").appendChild(div); */}
      </>
    );
  };

  /********************    For Spot mapping     *************** */

  const imgRef = React.createRef();

  const descriptionElementRef = React.useRef(null);

  React.useEffect(() => {
    setShowLoader(true);
    var bodyFormData = "";
    makeGetRequest(
      "society/getbyid/" + localStorage.getItem("socityid"),
      bodyFormData
    )
      .then((response) => {
        if (response.status === 201) {
          console.log("Society Data", response.data.data);
          // societyObj=response.data.data;
          setSocietyLayout(response.data.data.spot_layout);
          setSocietyGoogleMapImg(response.data.data.google_map_image);
          if (
            response.data.data.google_map_image == "" ||
            response.data.data.google_map_image == null
          ) {
            setNoGMapErr(
              "GoogleMap Not uploaded.. please upload gmap to configure security spots.."
            );
          } else {
            setNoGMapErr("");
            console.log("Society Data After assign " + societylayout);
            setRef_latitude(response.data.data.ref_latitude);
            setRef_longitude(response.data.data.ref_longitude);
            setSoc_bound_x_mtr(response.data.data.xaxis_in_meter);
            setSoc_bound_y_mtr(response.data.data.yaxis_in_meter);
            console.log("imgRef ",imgRef)
            var height = imgRef.current.height;
            var width = imgRef.current.width;
            console.log(height, width);
            setImgHeight(height);
            setImgWidth(width);
            console.log("Image Height / Width After assign in useeffect");
            console.log(imgHeight, imgWidth);
            //  const offsetX, offsetY } = imgRef.nativeEvent;
            //  console.log(imgRef.nativeEvent);

            getStatic_langlong();
          }
          printCoordinates();
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        console.log("There was an error!", err);
      });

    // timer = setInterval(() => {
      // getCoordinate();
    // }, 1000 * 10);
    // return () => clearInterval(timer);
  }, [imgHeight, imgWidth]);
  // End

  const spotClick = function (e) {
    var div = document.createElement("div");
    console.log(e);
    div.style.position = "absolute";
    div.style.top = e.clientY + "px";
    div.style.left = e.clientX + "px";
    div.innerHTML = "<span>Security Guard</span>";
    document.getElementById("contain").appendChild(div);
  };

  async function printCoordinates(e) {
    console.log("IN Imag Onload");

    var height = imgRef.current.height;
    var width = imgRef.current.width;
    console.log("Image Height / Width ");

    console.log(height, width);

    setImgHeight(height);
    setImgWidth(width);
    console.log("Image Height / Width  After assignment");
    console.log("ImgHeight " + imgHeight + " ImageWidth " + imgWidth);
    getStatic_langlong();
  }

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Configure Security Spots</h1>
            <p className="noUploadedImgError blink_me">
              {noGMapErr} &nbsp;
             
            </p>

            {noGMapErr ? (
              <Tooltip title={"Upload Google Map from here"} arrow>
              <Button
                className="primaryBtn"
                onClick={() => navigate("/BuildingYes")}
              >
                Upload GoogleMap
              </Button>
            </Tooltip>
            ) : (
              <Tooltip title={"Add Spot / Edit Spot"} arrow>
                <Button
                  className="primaryBtn"
                  onClick={() => navigate("/AddNewSpot")}
                >
                  Configure Spot
                </Button>
              </Tooltip>
            )}
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="confiSequSpotMain">
              {/* <p className="societyMapHeading">Society Map</p> */}
              <div className="confiSequSpotInner" style={{ marginTop: 0 }}>
                {/* <div className="addSpotsOutBt">
                  <Button className="addSpotsBt">Add Spots</Button>
                </div> */}
                <div className="spotImageView">
                  {/* <Button
                    className="addSpotsBt EditSpotsBt"
                    onClick={() => navigate("/AddNewSpot")}
                  >
                    Edit Spot
                  </Button> */}
                  {/* {societyGoogleMapImg ? (
                    <img src={societyGoogleMapImg} style={{ maxWidth: 800 }} />
                  ) : (
                    <img src={layOutDefault} style={{ maxWidth: 800 }} />
                  )} */}

                  {societyGoogleMapImg ? (
                    <>
                      <img
                        ref={imgRef}
                        src={societyGoogleMapImg}
                        // onLoad={(e) => printCoordinates(e)}
                      />
                      {PlotsArray.map((data, index) => {
                        return renderRow(data, index);
                      })}
                    </>
                  ) : (
                    <img
                      // ref={imgRef}
                      src={layOutDefault}
                      // onLoad={(e) => printCoordinates(e)}
                    />
                  )}

                  {/* <div className="spotCanvas">
                    <div id="contain" onClick={(e) => printCoordinates(e)}></div>
                  </div> */}
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default ConfigureSecuritySpots;
